export default {
    patientReports: {
        getAll: {
            type: 'get',
            showLoader: true,
            success: {
                default: null // No success message for loading data
            },
            error: {
                default: 'Failed to load patient reports',
                403: 'Access denied to patient reports',
                500: 'Server error occurred while loading reports'
            }
        },
        getByPatientId: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load patient reports',
                403: 'Access denied to this patient\'s reports',
                404: 'Patient not found',
                500: 'Server error occurred while loading patient reports'
            }
        },
        getById: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load patient report',
                403: 'Access denied to this patient report',
                404: 'Patient report not found',
                500: 'Server error occurred while loading report'
            }
        },
        create: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient report created successfully',
                201: 'Patient report created successfully'
            },
            error: {
                default: 'Failed to create patient report',
                400: 'Invalid report data provided',
                403: 'Access denied to create reports for this patient',
                500: 'Server error occurred while creating report'
            }
        },
        update: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient report updated successfully'
            },
            error: {
                default: 'Failed to update patient report',
                400: 'Invalid report data provided',
                403: 'Access denied to update this patient report',
                404: 'Patient report not found',
                500: 'Server error occurred while updating report'
            }
        },
        delete: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient report deleted successfully'
            },
            error: {
                default: 'Failed to delete patient report',
                403: 'Access denied to delete this patient report',
                404: 'Patient report not found',
                500: 'Server error occurred while deleting report'
            }
        },
        duplicate: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient report duplicated successfully'
            },
            error: {
                default: 'Failed to duplicate patient report',
                403: 'Access denied to duplicate this patient report',
                404: 'Patient report not found',
                500: 'Server error occurred while duplicating report'
            }
        },
        getTypes: {
            type: 'get',
            showLoader: false, // No loader for quick reference data
            success: {
                default: null
            },
            error: {
                default: 'Failed to load report types',
                500: 'Server error occurred while loading types'
            }
        },
        getModes: {
            type: 'get',
            showLoader: false, // No loader for quick reference data
            success: {
                default: null
            },
            error: {
                default: 'Failed to load report modes',
                500: 'Server error occurred while loading modes'
            }
        },
        getPatients: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load patients list',
                403: 'Access denied to patients list',
                500: 'Server error occurred while loading patients'
            }
        },
        getReportTemplates: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load report templates',
                500: 'Server error occurred while loading templates'
            }
        },
        validateContent: {
            type: 'post',
            showLoader: false, // Quick validation, no loader needed
            success: {
                default: null // No success message for validation
            },
            error: {
                default: 'Failed to validate content',
                500: 'Server error occurred during validation'
            }
        },
        getReportsByTemplate: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load reports by template',
                500: 'Server error occurred while loading reports'
            }
        },
        checkReportAccess: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Access denied to report',
                403: 'You do not have permission to access this report',
                404: 'Patient report not found'
            }
        },
        // Add export functionality
        export: {
            type: 'get',
            showLoader: true,
            success: {
                default: 'Report exported successfully'
            },
            error: {
                default: 'Failed to export report',
                404: 'Report not found',
                500: 'Server error occurred while exporting report'
            }
        }
    },
    reportTemplates: {
        getAll: {
            type: 'get',
            showLoader: true,
            success: {
                default: null // No success message for loading data
            },
            error: {
                default: 'Failed to load report templates',
                500: 'Server error occurred while loading templates'
            }
        },
        getById: {
            type: 'get',
            showLoader: true,
            success: {
                default: null // No success message for loading data
            },
            error: {
                default: 'Failed to load report template',
                404: 'Report template not found',
                500: 'Server error occurred while loading template'
            }
        },
        create: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Report template created successfully',
                201: 'Report template created successfully'
            },
            error: {
                default: 'Failed to create report template',
                400: 'Invalid template data provided',
                500: 'Server error occurred while creating template'
            }
        },
        update: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Report template updated successfully'
            },
            error: {
                default: 'Failed to update report template',
                400: 'Invalid template data provided',
                404: 'Report template not found',
                500: 'Server error occurred while updating template'
            }
        },
        delete: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Report template deleted successfully'
            },
            error: {
                default: 'Failed to delete report template',
                400: 'Cannot delete template that is in use',
                404: 'Report template not found',
                500: 'Server error occurred while deleting template'
            }
        },
        duplicate: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Report template duplicated successfully'
            },
            error: {
                default: 'Failed to duplicate report template',
                404: 'Report template not found',
                500: 'Server error occurred while duplicating template'
            }
        },
        getTypes: {
            type: 'get',
            showLoader: false, // No loader for quick reference data
            success: {
                default: null
            },
            error: {
                default: 'Failed to load template types',
                500: 'Server error occurred while loading types'
            }
        },
        getModes: {
            type: 'get',
            showLoader: false, // No loader for quick reference data
            success: {
                default: null
            },
            error: {
                default: 'Failed to load template modes',
                500: 'Server error occurred while loading modes'
            }
        },
        validateJson: {
            type: 'post',
            showLoader: false, // Quick validation, no loader needed
            success: {
                default: null // No success message for validation
            },
            error: {
                default: 'Failed to validate JSON',
                500: 'Server error occurred during validation'
            }
        },
        getTemplatesByType: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load templates by type',
                500: 'Server error occurred while loading templates'
            }
        },
        checkTemplateAccess: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Access denied to template',
                404: 'Report template not found',
                403: 'You do not have permission to access this template'
            }
        }
    },

    patientResources: {
        getByPatientId: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load patient resources',
                403: 'You do not have permission to access this patient data.',
                404: 'Patient not found',
                500: 'Server error occurred while loading resources'
            }
        },
        // NEW: Enhanced method for AI processing
        getByPatientIdForAI: {
            type: 'get',
            showLoader: true,
            success: {
                default: null // No success message for loading
            },
            error: {
                default: 'Failed to load patient resources for AI',
                403: 'Access denied to patient data for AI processing',
                404: 'Patient resources not found',
                500: 'Server error occurred while loading AI resources'
            }
        },
        // NEW: Get resource types for filtering
        getResourceTypes: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load resource types',
                500: 'Server error occurred while loading resource types'
            }
        },
        // NEW: Get resources by type
        getByPatientIdAndType: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load filtered resources',
                404: 'No resources found for this type',
                500: 'Server error occurred while loading filtered resources'
            }
        },
        // NEW: Search resources
        searchResources: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to search resources',
                500: 'Server error occurred while searching resources'
            }
        },
        // NEW: Get resource summary for AI
        getResourceSummary: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load resource summary',
                500: 'Server error occurred while loading summary'
            }
        },
        // ADD THIS NEW METHOD:
        getByReportId: {
            type: 'get',
            showLoader: true,
            success: {
                default: null
            },
            error: {
                default: 'Failed to load report resources',
                403: 'Access denied to report resources',
                404: 'Report not found or no resources found',
                500: 'Server error occurred while loading report resources'
            }
        },
        create: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient resource created successfully'
            },
            error: {
                default: 'Failed to create patient resource',
                400: 'Invalid resource data',
                403: 'You do not have permission to create resources for this patient.',
                500: 'Server error occurred while creating resource'
            }
        },
        update: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient resource updated successfully'
            },
            error: {
                default: 'Failed to update patient resource',
                400: 'Invalid resource data',
                404: 'Resource not found',
                500: 'Server error occurred while updating resource'
            }
        },
        delete: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Patient resource deleted successfully'
            },
            error: {
                default: 'Failed to delete patient resource',
                404: 'Resource not found',
                500: 'Server error occurred while deleting resource'
            }
        },
        // NEW: Bulk operations for resource management
        bulkSelect: {
            type: 'post',
            showLoader: true,
            success: {
                default: 'Resources selected successfully'
            },
            error: {
                default: 'Failed to select resources',
                500: 'Server error occurred during bulk selection'
            }
        },
        validateResourceAccess: {
            type: 'get',
            showLoader: false,
            success: {
                default: null
            },
            error: {
                default: 'Access denied to resource',
                403: 'You do not have permission to access this resource',
                404: 'Resource not found'
            }
        },

        
        /*Params:
         * #patientReportId: The report ID to get resources for
         */

        // Gets profile data formatted as resources
        getProfileResources: {
            type: "post",
            error: {
                default: "Failed to get profile resources.",
            },
        },
        /*Params:
         * #patientID: The patient ID to get profile data for
         * []profileSections: Array of profile section names to fetch
         *  - Possible values: Identity, Reason, Family, Medical, Substance, 
         *    Education, Employment, Social, Culture
         */

        /*Params:
         * <"+>resourceData: The resource data to save
         */

        // Clears all resources for a report
        clearResourcesForReport: {
            type: "delete",
            success: {
                default: "Successfully cleared resources.",
            },
            error: {
                default: "Failed to clear resources.",
            },
        },
        /*Params:
         * #patientReportId: The report ID to clear resources for
         */

        // Gets available profile sections
        getAvailableProfileSections: {
            type: "get",
            error: {
                default: "Failed to get profile sections.",
            },
        }
    }
};